import { GridColDef } from '@material-ui/data-grid'
import { months } from '../../../../constants'
import { TCFDISyncCategory, TCFDISyncStatus } from 'models/shared.models'
import { getFormattedDate, getFormattedTime } from 'lib/helpers/shared.helpers'
import {
  CFDISyncCategoriesLabelMap,
  CFDISyncProcessStatusIconsMap,
} from 'lib/utils/shared.utils'
import { ICFDISyncInformation } from 'store/SharedData/sharedData.models'
import SydTable from 'components/Shared/SydTable/SydTable'
import './styles.scss'

interface ISyncInformationDetailsTableProps {
  ongoingSyncProcesses: ICFDISyncInformation[]
  completedSyncProcesses: ICFDISyncInformation[]
}

const SyncInformationDetailsTable = ({
  ongoingSyncProcesses,
  completedSyncProcesses,
}: ISyncInformationDetailsTableProps) => {
  const orderedCFDISyncInformation = [
    ...ongoingSyncProcesses,
    ...completedSyncProcesses,
  ]

  const CFDISyncInformationTableColumns: GridColDef[] = [
    {
      field: '',
      headerName: 'Consulta',
      width: 160,
      sortable: false,
      renderCell: ({ row: { status, createdAt } }) => (
        <div className="process-info">
          <img
            src={CFDISyncProcessStatusIconsMap[status as TCFDISyncStatus].src}
            alt={CFDISyncProcessStatusIconsMap[status as TCFDISyncStatus].alt}
          />
          <span>{`${getFormattedDate(createdAt)} - ${getFormattedTime(createdAt)}`}</span>
        </div>
      ),
    },
    {
      field: 'year',
      headerName: 'Año',
      width: 64,
      sortable: false,
      renderCell: ({ row: { year } }) => year,
    },
    {
      field: 'month',
      headerName: 'Mes',
      width: 118,
      sortable: false,
      renderCell: ({ row: { startMonth, endMonth } }) =>
        startMonth && endMonth
          ? `${months[startMonth].substring(0, 3)}-${months[endMonth].substring(0, 3)}`
          : '---',
    },
    {
      field: 'category',
      headerName: 'Ingresos/Egresos',
      width: 122,
      sortable: false,
      align: 'right',
      renderCell: ({ row: { category } }) => (
        <div className="category">
          {CFDISyncCategoriesLabelMap[category as TCFDISyncCategory] ?? '---'}
        </div>
      ),
    },
  ]

  return (
    <SydTable
      className="sync-information-details-table-component"
      columns={CFDISyncInformationTableColumns}
      rows={orderedCFDISyncInformation}
      rowCount={orderedCFDISyncInformation.length}
      rowHeight={40}
      checkboxSelection={false}
      noBorder
    />
  )
}

export default SyncInformationDetailsTable
